import clsx from 'clsx';
import { ReactNode } from 'react';

import { CoreIcon } from '../icon';
import { IconPosition } from '../shared/types/text-field.types';

import styles from './text-field.module.scss';

interface ClearAllButtonProps {
  showClearAll?: boolean;
  value: string | number;
  isEditing: boolean;
  tempValue: string | number;
  icon?: ReactNode;
  iconPosition?: IconPosition;
  onClear: () => void;
}

export const ClearAllButton = ({
  showClearAll,
  value,
  isEditing,
  tempValue,
  icon,
  iconPosition,
  onClear,
}: ClearAllButtonProps) => {
  if (!showClearAll || !(value || (isEditing && tempValue))) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={onClear}
      className={clsx(
        styles['core-form-input-control'],
        styles['core-form-input-control-trailing'],
        iconPosition === 'trailing' &&
          icon &&
          styles['text-field-clear-all-button-with-trailing']
      )}
    >
      <span className={styles['core-visually-hidden']}>Clear the field</span>
      <CoreIcon name="action-x-mark" ariaHidden />
    </button>
  );
};
